import { render, staticRenderFns } from "./Recruitment.vue?vue&type=template&id=a88b9ae4&scoped=true"
import script from "./Recruitment.vue?vue&type=script&lang=js"
export * from "./Recruitment.vue?vue&type=script&lang=js"
import style0 from "./Recruitment.vue?vue&type=style&index=0&id=a88b9ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88b9ae4",
  null
  
)

export default component.exports